<!-- eslint-disable -->
<template>
  <div class="G_modal">
    <modal-header
      @event-close-child-modals="eventCloseChildModals"
      @event-close-modal="selfClose"
      :title="modalTitle">
    </modal-header>
    <hr>

    <div class="c2m8_grid_container">
      
      <div class="c2m8_name_label">Group Name</div>
      <div class="c2m8_name_field_div">
        <input class="c2m8_name_field" v-model="DV_groupName" type="text" placeholder="Enter Group Name">
      </div>
      <div class="c2m8_description_label">Description</div>
      <div class="c2m8_name_description_div">
        <input class="c2m8_description_field" v-model="DV_orgDescription" type="text"  placeholder="Group Description">
      </div>
      <div class="c2m8_buttons">
        <button 
          :disabled="!userPermissions.includes('a') && !userPermissions.includes('t')"
          @click.stop="createGroup" 
          class="c2m8_create_org_button c2m4_buttons">Create Group</button>
        <button @click.stop="selfClose" class="c2m8_cancel_button c2m4_buttons">Cancel</button>
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable */
import ModalHeader from "../../p2ModalHeader";
import { bi10ModalTemplate, bi10OrgPermissions } from "../../../../watchdog_includes/base_i10_UI_mixins";
import createNotificationGroup from "../../../../watchdog_includes/json_tasks/p2s9/p2s9t2";
import AWN from "awesome-notifications";

export default {
  name: "c3m2CreateNewGroup",
  mixins: [bi10ModalTemplate, bi10OrgPermissions],
  props: ['orgUid'],
  components: {
    ModalHeader
  },
  data: function() {
    return {
      modalTitle:'Create Group',
      defaultModal:'default',
      DV_groupName: '',
      DV_orgDescription: '',
      actualOrgUid: null
    };
  },
  methods: {
    waitWatchdogReadyCallback() {
      this.actualOrgUid = this.orgUid;
      this.bi10GetOrgPermissions(this.orgUid);
    },
    createGroup() {
      if (this.DV_groupName == null || this.DV_groupName == undefined || this.DV_groupName.length == 0) {
        this.$awn.warning("Please enter valid notification group name.");
        return;
      }
      var popup_options = {
        labels: {
          async: "Creating Notification Group",
        },
        duration: 3000,
      };
      let notifier = new AWN(popup_options);
      var resp = createNotificationGroup(
        window.G_firebase_auth.IV_email_address,
        window.G_firebase_auth.IV_id_token,
        `usr_${window.G_watchdog_data.IV_user_info["uid"]}`,
        this.actualOrgUid,
        this.DV_groupName,
        this.DV_orgDescription
      );
      notifier.async(resp,
        (res) => {
          notifier.success(`Group created successfully...`);
        },
        (error) => {
          notifier.alert("There was an error creating notification group, Please try later.");
        } 
      );

      this.selfClose()
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s2notifications/p2s2m2/c3m2CreateNewGroup.vue